import React from 'react';
import constant from "lodash/constant";
import noop from "lodash/noop";
export var AccordionContext = React.createContext({
  isAccordionOpen: constant(false),
  toggleAccordionOpen: noop,
  stateCallBack: noop
});